import {
  COLOR_PALETTE_TOOL,
  COLOR_PICKER_TOOL,
  FONT_GENERATOR_TOOL,
  SingleToolFooter,
  SingleToolSimilar,
  ToolCategory,
  COLOR_WHEEL_TOOL,
} from '@quicktools/shared-components';
import { useTranslation } from 'react-i18next';

import analytics from '../../services/analytics';

import FaqSection from './FaqSection';
import HowToSection from './HowToSection';
import ImageSectionWhat from './ImageSectionWhat';
import ImageSectionWhy from './ImageSectionWhy';
import TabbedSection from './TabbedSection';

const SIMILAR_TOOLS = [COLOR_PALETTE_TOOL, FONT_GENERATOR_TOOL, COLOR_PICKER_TOOL];

function Landing() {
  const { t } = useTranslation();

  return (
    <>
      <ImageSectionWhat />
      <TabbedSection />
      <HowToSection />
      <ImageSectionWhy />
      <FaqSection />
      <SingleToolSimilar
        category={ToolCategory.Color}
        current={COLOR_WHEEL_TOOL}
        analytics={analytics}
        similar={SIMILAR_TOOLS}
        paragraph={t('landing.similarTools.paragraph')}
      />
      <SingleToolFooter analytics={analytics} />
    </>
  );
}

export default Landing;
